export default "__VITE_ASSET__BBqo6ttn__"